import crud from './_crud'
import { callApi } from 'utils/api'
const actions = crud(
	'inspection_category',
	'la categoria de inspección',
	'las categorias de inspección'
)

const loadCategories = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/inspection_category/load_categories`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options,
		})

		dispatch({
			type: 'LOAD_INSPECTION_CATEGORIES',
			payload: res.body,
		})

		return res.body
	}
}

export default { ...actions, loadCategories }
